<template>
    <el-dialog
        :title="$t('message.cdata.diaTitle')"
        :visible="dialogVisible"
        @close="handleClose"
        class="data_dialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false">
        <!-- 添加部分 -->
        <div class="data_dialog_add">
            <!-- 输入框 -->
            <el-input
                size="small"
                v-model="add_form.email"
                class="data_dialog_add_input"
                clearable>
            </el-input>
            <!-- 是否默认 -->
            <el-checkbox
                v-model="add_form.is_default">
                <span>{{$t("message.cdata.isdefault1")}}</span>
            </el-checkbox>
            <!-- 添加按钮 -->
            <el-button
                type="primary"
                size="small"
                @click="handleAdd(add_form)">
                <span>{{$t("message.cdata.addBtn")}}</span>
            </el-button>
        </div>
        <!-- 表格部分 -->
        <el-table
            :data="email_list"
            height="300">
            <!-- 邮箱列 -->
            <el-table-column
                :label="$t('message.cdata.table1')">
                <template v-slot="{row}">
                    <list-input
                        :input-value="row.email"
                        :ref="row.id">
                    </list-input>
                </template>
            </el-table-column>
            <!-- 默认邮箱列 -->
            <el-table-column
                :label="$t('message.cdata.table2')"
                align="center"
                width='100'>
                <template v-slot="{row}">
                    <data-dialog-checked
                        :is-default="row.status"
                        :email-id="row.id">
                    </data-dialog-checked>
                </template>
            </el-table-column>
            <!-- 操作 -->
            <el-table-column
                :label="$t('message.cdata.table3')"
                align="center"
                width="150">
                <template v-slot="{ row }">
                    <el-button
                        type="primary"
                        size="mini"
                        @click="handleChange(row)">
                        <span>{{$t("public.modifyBtn")}}</span>
                    </el-button>
                    <el-button
                        type="danger"
                        size="mini"
                        @click="handleDel(row.id)">
                        <span>{{$t("public.delBtn")}}</span>
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
    </el-dialog>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";

export default {
    data() {
        return {
            add_form: { // 添加邮箱信息
                email: "",
                is_default: false,
            },
        }
    },
    computed: mapState({
        dialogVisible: state => state.dialogVisible,
        email_list: state => state.user.email_list,
    }),
    components: {
        listInput: () => import("@/components/listInput"),
        dataDialogChecked: () => import("@/components/center/dataDialogChecked")
    },
    methods: {
        ...mapMutations([
            "handleDialog"
        ]),
        ...mapActions([
            "getCompanyEmail",
            "handleChangeEmail",
            "getCompanyData",
            "handleAddEmail",
            "handleDelEmail"
        ]),
        clearForm(){
            this.add_form = {
                email: "",
                is_default: false
            }
        },
        handleClose(){ // 关闭模态框
            this.handleDialog();
            this.getCompanyData();
            this.clearForm();
        },
        handleAdd(form){ // 添加邮箱
            if(form.email == ""){
                this.$message({
                    showClose: true,
                    message: this.$t("message.cdata.errormsg"),
                    type: "error"
                })
                return
            }
            this.handleAddEmail({
                email: form.email,
                status: form.is_default?0:1
            })
            this.clearForm();
        },
        handleChange(item){
            let id = item.id,
            email = this.$refs[id].value,
            status = item.status;
            this.handleChangeEmail({
                id,
                email,
                status
            }).then((res) => {
                if(res){
                    this.$message({
                        showClose: true,
                        message: this.$t("message.cdata.succmsg1"),
                        type: "success"
                    })
                }
            })
        },
        handleDel(id){ // 删除邮箱
            this.handleDelEmail(id).then((res) => {
                if(res.type){
                    this.$message({
                        showClose: true,
                        message: this.$t("public.delSucc"),
                        type: "success"
                    })
                    setTimeout(() => {
                        this.getCompanyEmail();
                    }, 1000)
                }
            }).catch(() => {})
        }
    },
}
</script>

<style scoped>
/* 添加部分盒子 */
.data_dialog_add{
    padding-bottom: 30px;
    border-bottom: 1px solid #EBEEF5;
}
/* 添加输入框 */
.data_dialog_add_input{
    width: 300px;
    margin-right: 15px;
}
</style>
